var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'text-center': _vm.centered }},[_c('b-spinner',{attrs:{"variant":"primary","label":"Загрузка"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }